import 'can-construct-super';
import Control from 'can-control';

import MenuHyper from "@/js/controllers/menu/hyper.js";
// import MenuMobile from "@/js/controllers/menu/mobile.js";

/**s
 * Стандартный контроллер для шапки
 **/

const HeaderBase = Control.extend(
    {
        defaults: {}
    },
    {
        init() {
           new MenuHyper('.site-navigation .navbar');
           // new MenuMobile('.site-navigation .navbar');
        },
    }
);

export default HeaderBase;